import React from 'react'
import SearchCars from "../components/SearchCars";
import { Helmet } from 'react-helmet';

function AirFilters() {

  const pageTitle = "Филтри за воздух - Пребарување на автомобилски филтри за воздух | Filter za vozduh za tvojot avtomobil. ";
  const pageDescription = "Пронајди филтри за воздух за твоето возило. Погледни ги различните опции за филтри за воздух за твојот автомобили и подобри ја работата на моторот. Golem izbor na filtri za vozduh.";
  const pageKeywords = "филтри за воздух, филтри за автомобили, авто филтри, филтри за воздух за автомобил, автомобилски делови, моторни филтри";

  return (
    <>

      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>
      <div className='flex flex-col justify-start items-center'>
        <h1 className='text-4xl font-bold mb-8'>Филтри за воздух</h1>
        <SearchCars category={3} allFilters={false} />
      </div>
    </>
  )
}

export default AirFilters
